import { ReactNode } from 'react'

import EmberLogo from './EmberLogo'
import Footer from './Footer'
import GradientBackground from './GradientBackground'
import Navbar from './Navbar'

interface Props {
  children?: ReactNode
}

const Layout = ({ children, ...props }: Props) => {
  return (
    <>
      <div
        id="mainbg"
        className="grid w-screen h-full min-h-screen overflow-x-hidden overflow-y-visible duration-500 ease-in-out select-none md:grid-rows-layout landscape:grid-rows-layout portrait:grid-rows-mobile bg-primarybg max-w-screen"
      >
        <Navbar />
        <EmberLogo />
        <GradientBackground />
        <main
          className="grid items-center w-screen mt-6 grid-col sm:mt-4 h-max"
          {...props}
        >
          {children}
        </main>
        <Footer />
      </div>
    </>
  )
}

export default Layout
